// GENERATED by scripts/sync-standard.mjs from Assessments/assessment-standard.json.
// DO NOT EDIT. Edit the standard, then run `npm run standard:sync` (prebuild runs it too).
// Source version: "2026-09-02". 4 monthly group(s), 30 component
// rows, each verified against the standard's own totals before emission.

/** Difficulty bands as the standard names them. */
export type StandardBand = "easy" | "medium" | "difficult";

export interface StandardComponent {
  name: string;
  /** Item count this component carries in the monthly frame. */
  items: number;
  /** The frame's own E/M/D allocation for this component. They sum to `items`. */
  easy: number;
  medium: number;
  difficult: number;
}

export interface StandardGroup {
  key: string;
  grades: number[];
  components: StandardComponent[];
}

/** tiers.monthly.items — the monthly paper's item count. */
export const MONTHLY_ITEMS = 30;

/** tiers.monthly.difficulty_by_items — 20/60/20 of 30 items, as counts. */
export const MONTHLY_DIFFICULTY_COUNTS: Record<StandardBand, number> = {"easy":6,"medium":18,"difficult":6};

/** tiers.sa.written.difficulty_by_items_pct — the shares the count rule rounds. */
export const DIFFICULTY_PCT: Record<StandardBand, number> = {"easy":20,"medium":60,"difficult":20};

/** The standard's own wording of the count rule, carried verbatim for the message text. */
export const DIFFICULTY_RULE_TEXT = "easy=difficult=round_half_up(0.20*n); medium=n-easy-difficult";

export const MONTHLY_GROUPS: StandardGroup[] = [
  {
    "key": "g1_g3",
    "grades": [
      1,
      2,
      3
    ],
    "components": [
      {
        "name": "Spelling",
        "items": 3,
        "easy": 2,
        "medium": 1,
        "difficult": 0
      },
      {
        "name": "Dictation",
        "items": 3,
        "easy": 0,
        "medium": 3,
        "difficult": 0
      },
      {
        "name": "Listening",
        "items": 5,
        "easy": 2,
        "medium": 3,
        "difficult": 0
      },
      {
        "name": "Vocabulary",
        "items": 6,
        "easy": 2,
        "medium": 4,
        "difficult": 0
      },
      {
        "name": "Grammar",
        "items": 4,
        "easy": 0,
        "medium": 3,
        "difficult": 1
      },
      {
        "name": "Reading",
        "items": 4,
        "easy": 0,
        "medium": 2,
        "difficult": 2
      },
      {
        "name": "Visual Reading",
        "items": 3,
        "easy": 0,
        "medium": 1,
        "difficult": 2
      },
      {
        "name": "Writing",
        "items": 2,
        "easy": 0,
        "medium": 1,
        "difficult": 1
      }
    ]
  },
  {
    "key": "g4_g7",
    "grades": [
      4,
      5,
      6,
      7
    ],
    "components": [
      {
        "name": "Spelling",
        "items": 3,
        "easy": 2,
        "medium": 1,
        "difficult": 0
      },
      {
        "name": "Dictation",
        "items": 3,
        "easy": 0,
        "medium": 2,
        "difficult": 1
      },
      {
        "name": "Listening",
        "items": 5,
        "easy": 2,
        "medium": 3,
        "difficult": 0
      },
      {
        "name": "Vocabulary",
        "items": 5,
        "easy": 2,
        "medium": 3,
        "difficult": 0
      },
      {
        "name": "Grammar",
        "items": 5,
        "easy": 0,
        "medium": 4,
        "difficult": 1
      },
      {
        "name": "Reading",
        "items": 5,
        "easy": 0,
        "medium": 3,
        "difficult": 2
      },
      {
        "name": "Visual Reading",
        "items": 3,
        "easy": 0,
        "medium": 2,
        "difficult": 1
      },
      {
        "name": "Writing",
        "items": 1,
        "easy": 0,
        "medium": 0,
        "difficult": 1
      }
    ]
  },
  {
    "key": "g8_g10",
    "grades": [
      8,
      9,
      10
    ],
    "components": [
      {
        "name": "Spelling",
        "items": 3,
        "easy": 2,
        "medium": 1,
        "difficult": 0
      },
      {
        "name": "Dictation",
        "items": 3,
        "easy": 0,
        "medium": 3,
        "difficult": 0
      },
      {
        "name": "Listening",
        "items": 5,
        "easy": 2,
        "medium": 3,
        "difficult": 0
      },
      {
        "name": "Vocabulary",
        "items": 4,
        "easy": 2,
        "medium": 2,
        "difficult": 0
      },
      {
        "name": "Grammar",
        "items": 5,
        "easy": 0,
        "medium": 4,
        "difficult": 1
      },
      {
        "name": "Reading",
        "items": 5,
        "easy": 0,
        "medium": 3,
        "difficult": 2
      },
      {
        "name": "Visual Reading",
        "items": 3,
        "easy": 0,
        "medium": 2,
        "difficult": 1
      },
      {
        "name": "Writing",
        "items": 2,
        "easy": 0,
        "medium": 0,
        "difficult": 2
      }
    ]
  },
  {
    "key": "g11_g12",
    "grades": [
      11,
      12
    ],
    "components": [
      {
        "name": "Listening",
        "items": 6,
        "easy": 3,
        "medium": 3,
        "difficult": 0
      },
      {
        "name": "Vocabulary",
        "items": 6,
        "easy": 3,
        "medium": 3,
        "difficult": 0
      },
      {
        "name": "Grammar",
        "items": 6,
        "easy": 0,
        "medium": 5,
        "difficult": 1
      },
      {
        "name": "Reading",
        "items": 7,
        "easy": 0,
        "medium": 5,
        "difficult": 2
      },
      {
        "name": "Visual Reading",
        "items": 3,
        "easy": 0,
        "medium": 2,
        "difficult": 1
      },
      {
        "name": "Writing",
        "items": 2,
        "easy": 0,
        "medium": 0,
        "difficult": 2
      }
    ]
  }
];

/** Half-up rounding, as the standard's `round_half_up` means it. Math.round is half-up for
 *  positives but says so nowhere; this names the intent so a reader need not check. */
export function roundHalfUp(value: number): number {
  return Math.floor(value + 0.5);
}

/**
 * The standard's difficulty count rule for a paper of `n` items:
 *   easy = difficult = round_half_up(0.20 * n); medium = n − easy − difficult
 * At n = 30 this gives 6/18/6, which is what
 * tiers.monthly.difficulty_by_items states independently — the two agree by arithmetic, not luck.
 */
export function difficultyCountsFor(n: number): Record<StandardBand, number> {
  const easy = roundHalfUp((DIFFICULTY_PCT.easy / 100) * n);
  const difficult = roundHalfUp((DIFFICULTY_PCT.difficult / 100) * n);
  return { easy, medium: n - easy - difficult, difficult };
}

/** The frame governing a given grade, or null for a grade the standard does not slot. */
export function groupForGrade(grade: number): StandardGroup | null {
  return MONTHLY_GROUPS.find((g) => g.grades.includes(grade)) ?? null;
}

/** The frame's allocation for one component, or null when the frame does not name it. */
export function componentFrame(group: StandardGroup, component: string): StandardComponent | null {
  return group.components.find((c) => c.name === component) ?? null;
}
